import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link, Navigate } from "react-router-dom";
import { useRouteMatch } from "../../hooks/framework/useRouteMatch";
import { useMediaQuery } from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
}

interface ILinkTab {
    value: string;
    label: string;
    matchPaths: string[];
    to: string;
    children?: React.ReactNode;
}

interface MuiTabsProps {
    tabs: ILinkTab[];
}

function TabPanel(props: TabPanelProps) {
    const { children, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {children}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export const LinkTabs = ({ tabs }: MuiTabsProps) => {
    const routeMatch = useRouteMatch(tabs.flatMap((t) => t.matchPaths));
    const isSmallScreen = useMediaQuery("(max-width: 640px)");
    const currentPath = routeMatch?.pattern?.path;
    const currentIndex = tabs.findIndex((t) =>
        t.matchPaths.some((p) => p === currentPath)
    );
    const currentTab = tabs[currentIndex];
    if (!currentTab) {
        return <Navigate to={tabs[0].to} replace />;
    }

    return (
        <>
            <Tabs
                variant="fullWidth"
                orientation={isSmallScreen ? "vertical" : "horizontal"}
                value={currentTab.value}
            >
                {tabs.map((t, i) => (
                    <Tab
                        key={t.value}
                        label={t.label}
                        value={t.value}
                        {...a11yProps(i)}
                        to={t.to}
                        component={Link}
                    />
                ))}
            </Tabs>
            <TabPanel index={currentIndex}>{currentTab.children}</TabPanel>
        </>
    );
};
